import {
  createSharedState,
  SharedEntityState,
} from '@ideapa/app-base-components';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer } from '@ngrx/store';

import { ENTITY } from './constants';
import { ScritturaElisione as Entity } from './models';

export const ENTITY_FEATURE_KEY = ENTITY;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface State extends SharedEntityState<Entity> {}

export const entityAdapter: EntityAdapter<Entity> = createEntityAdapter<Entity>(
  {
    selectId: (item) => item.id,
  }
);

export const entityState = createSharedState<Entity>(ENTITY);

export const initialState: State = entityState.getInitialState();

export const sharedActions = entityState.getActions();

export const rawReducer = entityState.extendBaseReducer(
  initialState,
  sharedActions,
  entityAdapter,
  createReducer(initialState),
  true
);
